import { cn } from "../../utils";
import { Typography } from "../typography";
import type { ChatHeroProps } from "./types";

function getTimeOfDayGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning,";
  if (hour < 18) return "Good afternoon,";
  return "Good evening,";
}

export function ChatHero({ heading, subheading, className }: ChatHeroProps) {
  return (
    <div className={cn("max-w-2xl mx-auto w-full mt-8 sm:mt-16 space-y-4 pb-4 sm:pb-8", className)}>
      <div className="max-w-lg space-y-1">
        <Typography.GreetingLabel>{getTimeOfDayGreeting()}</Typography.GreetingLabel>
        <Typography.GreetingHeading>{heading}</Typography.GreetingHeading>
      </div>
      <Typography.GreetingSubheading className="max-w-lg">
        {subheading}
      </Typography.GreetingSubheading>
    </div>
  );
}
